import { useEffect } from 'react';
import type { FC } from 'react';

// Externals
import { Box } from '@mui/material';
import NProgress from 'nprogress';

const LoadingScreen: FC = () => {
  useEffect(() => {
    NProgress.start();

    return (): void => {
      NProgress.done();
    };
  }, []);

  return (
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100%'
      }}
    />
  );
};

export default LoadingScreen;
